export default __webpack_public_path__ + "static/media/ad_6.2c98cefc.mp3";